// extracted by mini-css-extract-plugin
module.exports = {"root":"NavigationItem-root-1-SV7","anchor":"NavigationItem-anchor-2E44W typography-navItem-4NY75","active":"NavigationItem-active-2zugT typography-navItemActive-1gPXi"};